import { Routes } from '@angular/router';

import { Home }
from './pages/home/home';

import { Products }
from './admin/products/products';

import { Settings }
from './admin/settings/settings';

import { Login }
from './pages/login/login';

import { authGuard }
from './guards/auth-guard';

import { ProductsList }
from './admin/products-list/products-list';

import { CategoryProducts }
from './pages/category-products/category-products';

import { Contact }
from './pages/contact/contact';

import { ProductShowcase }
from './pages/product-showcase/product-showcase';

import { CategoriesList }
from './admin/categories-list/categories-list';

import { CategoriesCreate }
from './admin/categories-create/categories-create';

import { CategoriesEdit }
from './admin/categories-edit/categories-edit';

import { Dashboard }
from './admin/dashboard/dashboard';


import { GalleryComponent } from './admin/gallery/gallery';
import { GalleryPage } from './pages/gallery/gallery';
export const routes: Routes = [
{
  path: 'admin',
  component: Dashboard,
  canActivate: [authGuard]
},


{
  path: 'admin/products/details/:id',

  loadComponent: () =>
    import('./admin/product-showcase/product-showcase')
      .then(m => m.ProductShowcase),

  canActivate: [authGuard]
},

  // HOME
  {
    path: '',
    component: Home
  },

  // CATEGORY PRODUCTS
  {
    path: 'category/:slug',
    component: CategoryProducts
  },
{
  path: 'admin/gallery',
  component: GalleryComponent,
  canActivate: [authGuard]
},
{
  path: 'gallery',
  component: GalleryPage
},
//Contact page
{
  path: 'contact',
  component: Contact
},
  {
  path: 'admin/settings',
  component: Settings,
  canActivate: [authGuard]
},
  // ADMIN CATEGORIES LIST
  {
    path: 'admin/categories',
    component: CategoriesList,
    canActivate: [authGuard]
  },

  // ADMIN CREATE CATEGORY
  {
    path: 'admin/categories/new',
    component: CategoriesCreate,
    canActivate: [authGuard]
  },

  // ADMIN EDIT CATEGORY
  {
    path: 'admin/categories/edit/:id',
    component: CategoriesEdit,
    canActivate: [authGuard]
  },
  // PRODUCT DETAILS
  {
    path: 'product/:slug',
    component: ProductShowcase
  },

  // ADMIN ADD PRODUCT
  {
    path: 'admin/products/new',
    component: Products,
    canActivate: [authGuard]
  },

  // ADMIN PRODUCTS LIST
  {
    path: 'admin/products',
    component: ProductsList,
    canActivate: [authGuard]
  },

  // ADMIN EDIT PRODUCT
  {
    path: 'admin/products/edit/:id',

    loadComponent: () =>
      import('./admin/products-edit/products-edit')
      .then(m => m.ProductsEdit),

    canActivate: [authGuard]
  },

  // LOGIN
  {
    path: 'login',
    component: Login
  },

  // FALLBACK
  {
    path: '**',
    redirectTo: ''
  }
];